import config from '../../../assets/config.json'
export const APP_LOADING = 'APP_LOADING';

export class Constants {
  public static MaxInt32 = 2147483647;

  public static PageSize = 20;

  // regex
  public static Regex_Email = /[^.][a-zA-Z0-9.-_][^<>/:;,+=@]{1,}@[a-zA-Z]{2,}[.][a-zA-Z]{2,}/;
  // public static Regex_Phone = /^(0?)(3[2-9]|5[6|8|9]|7[0|6-9]|8[0-6|8|9]|9[0-4|6-9])[0-9]{7}$/;
  public static Regex_Phone = /^[0-9]{10}$/;
  public static Regex_TimeFormat = /^([0-1]?d|2[0-3]):[0-5]d$/;
  public static Regex_OnlyNumber = /^\d*$/;
  public static Regex_AlphabetAndNumeric = /^[a-zA-Z0-9]*$/;
  public static Regex_AlphabetNumericSpace = /^[a-zA-Z0-9 ]*$/;
  public static Regex_BlockSpecialCharacter = /^[^~`!@#$%^&()_={}[\]:;,.<>+\/?-]*$/;

  // date format
  public static DATE_FORMAT = 'DD/MM/YYYY';
  public static API_ENDPOINT = config.backendUrl;
  public static CATEGORY_ID_NEWS = 'f85fa088-0f78-4e4d-bc03-b8443dbf2ce0'
  public static CATEGORY_ID_BLOG = 'aeb02ade-9b63-46ea-9ea2-c412567dd70a'
  public static CATEGORY_ID_PRODUCT = '16521511-da29-429a-b46c-db7d938138b2'
  public static CATEGORY_ID_RECRUITMENT = '5afa52cf-3793-4721-9dd7-08abdc8b3410'
  public static CATEGORY_ID_SERVICE = '2918b76b-20de-498b-b5e4-beb09d13df71'
  public static CATEGORY_NEWS = 'new'
  public static CATEGORY_BLOG = 'blog'
  public static ORDER_BY_READ_COUNT = 'isMostRead'
}
